<template>
    <div id="why-consort" class="mx-auto max-w-screen-xl">
        <MoleculesLoadingOverlay v-if="loading" />
        <Organisms v-else :organisms="organisms" />
    </div>
</template>

<style>
#why-consort {
    .wysiwyg-block {
        @apply mx-8;

        h3 {
            @apply text-primary-500 text-3xl mb-4 border-b-2 border-accent-950 w-fit pb-2;
        }

        p {
            @apply mb-4;
        }

        li {
           @apply list-disc ml-4 pb-2;
        }

        @media screen and (max-width:767px) {
            iframe {
                @apply h-[200px];
            }
        }
    }

    .split-content {
        h3 {
            @apply text-3xl font-bold md:text-[40px] font-figtree text-primary-500 uppercase mb-6;
        }
    }

}
</style>

<script setup>
//import { useQuery } from "@vue/apollo-composable";
import { useAsyncQuery } from "#imports";
import { GET_ORGANISMS } from "~/graphql/GetOrganisms";

import { storeToRefs } from "pinia";
const breadcrumbs = useBreadcrumbs();
const { breadcrumbsList } = storeToRefs(breadcrumbs);

const { data, pending, error } = await useAsyncQuery(GET_ORGANISMS, {
    uri: "/about/why-consort/",
});

const organisms = computed(() => {
    return data.value?.organisms?.hlOrganisms?.hlOrganism ?? [];
});

const loading = pending;

breadcrumbsList.value = [{ title: "Why Consort", link: "" }];
</script>
